var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.validUser)?_c('div',[_c('router-view')],1):_c('div',{staticStyle:{"background":"#F8F8F9 !important","height":"100vh"}},[_c('NotAuthentication')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }